import { MiniCardContainer, MiniCardTitle, MiniCardDescription, MiniCardButton } from "./styles";

export default function MiniCard({ title, description, buttonLabel, buttonLink, icon }) {

  return (
    <MiniCardContainer>
      <MiniCardTitle>{ icon && <span className="icon">{ icon }</span> }{ title }</MiniCardTitle>
      <MiniCardDescription>{ description }</MiniCardDescription>
      <MiniCardButton href={ buttonLink } target="_blank">{ buttonLabel }</MiniCardButton>
    </MiniCardContainer>
  );
}